import isNonEmpty from '~/utils/fnUtil/isNonEmpty';
import { isNil } from 'ramda';

export default class PromiseQueue {
  queue = {};
  isRunning = false;

  push(key, item) {
    if (isNil(this.queue[key])) {
      this.queue[key] = [];
    }
    const queue = this.queue[key];
    queue.push(item);

    if (!this.isRunning) {
      return this.run(key);
    }
  }

  async run(key) {
    if (isNonEmpty(this.queue[key])) {
      this.isRunning = true;
      const promiseItem = this.queue[key].shift();
      try {
        await promiseItem.do();
      } catch (e) {
        promiseItem.onError(e, promiseItem);
      } finally {
        if (isNonEmpty(this.queue[key])) {
          return this.run(key);
        }
      }
    }

    this.isRunning = false;
    return Promise.resolve();
  }
}
export const promiseQueue = new PromiseQueue();
